"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(theme) {
  return {
    Menu: {
      margin: 0,
      borderRadius: 6,
      border: {
        width: 1,
        style: 'solid',
        color: theme['$menu-border-color']
      },
      boxShadow: {
        y: 2,
        blur: 0,
        color: theme['$shadow-color']
      },
      '& > ul': {
        padding: 0,
        margin: 0
      },
      background: theme['$menu-background-color'],
      userSelect: 'none',
      '& > *': {
        marginBottom: 4
      },
      '& .menu-searchbox': {
        margin: 5
      }
    }
  };
};

exports["default"] = _default;
//# sourceMappingURL=style.js.map